import { Element4, Heart, MessageTime, Notepad2, Star, User } from 'iconsax-react';
// routes
import {
  PATH_HOME,
  PATH_CUSTOMER,
  PATH_PROVIDER,
  PATH_JOB_BOARD,
  PATH_SERVICES,
  PATH_MESSAGES,
} from '../../../../shared/routes/paths';

// ----------------------------------------------------------------------

export const headerConfig = (hasUnreadMessages) => [
  {
    items: [
      {
        title: 'home',
        path: PATH_HOME.root,
        loggedIn: true,
        loggedOut: true,
      },
    ],
  },
  {
    items: [
      {
        title: 'dashboard',
        path: PATH_CUSTOMER.dashboard,
        loggedIn: true,
        loggedOut: false,
      },
    ],
  },
  {
    items: [
      {
        title: 'job board',
        path: PATH_JOB_BOARD.root,
        loggedIn: true,
        loggedOut: true,
      },
    ],
  },
  {
    items: [
      {
        title: 'services',
        path: PATH_SERVICES.list,
        loggedIn: true,
        loggedOut: true,
      },
    ],
  },
  {
    items: [
      {
        title: 'messages',
        path: PATH_MESSAGES.root,
        loggedIn: true,
        loggedOut: false,
        hasUnreadMessages,
      },
    ],
  },
];

export const getSideConfig = (providerNavItems, hasExpiredBookings) => [
  {
    items: [
      {
        title: 'Customer',
        path: PATH_CUSTOMER.dashboard,
        collapsible: true,
        icon: <User />,
        children: [
          { title: 'Dashboard', path: PATH_CUSTOMER.dashboard, icon: <Element4 /> },
          { title: 'My Profile', path: PATH_CUSTOMER.profile, icon: <User /> },
          {
            title: 'My Bookings',
            path: PATH_CUSTOMER.bookings.root,
            icon: <MessageTime />,
            hasExpiredBookings,
          },
          { title: 'Jobs Posted', path: PATH_CUSTOMER.jobs.root, icon: <Notepad2 /> },
          { title: 'Favourites', path: PATH_CUSTOMER.favourites, icon: <Heart /> },
          { title: 'Reviews', path: PATH_CUSTOMER.reviews, icon: <Star /> },
        ],
      },
      {
        title: 'Provider',
        path: PATH_PROVIDER.dashboard,
        collapsible: true,
        icon: <User />,
        children: providerNavItems,
      },
    ],
  },
];

export const footerConfig = [
  {
    title: 'Home',
    path: 'https://stintz.com/',
  },
  {
    title: 'About',
    path: 'https://stintz.com/about-local-services/',
  },
  {
    title: 'FAQs',
    path: 'https://stintz.com/faq/',
  },
  {
    title: 'Blog',
    path: 'https://stintz.com/blog/',
  },
  {
    title: 'Contact',
    path: 'https://stintz.com/contact-us/',
  },
];
